import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListItem, MatNavList } from '@angular/material/list';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrl: './nav-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatNavList, MatListItem, MatIconModule, RouterModule],
})
export class NavMenuComponent {
  isExpanded = true;
  isShowing = false;
  currentUrl = location.pathname;
}
